// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FAQItem_container__4DWj7 {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  background-color: transparent;
  border-radius: 16px;
  border: 1.5px solid var(--primary-dark);
  margin-bottom: 16px;
  padding: 20px 20px;
  outline: none;
  font-size: var(--font-size-6);
  color: var(--primary-light);
}

.FAQItem_containerExpanded__E4k-Q {
  background-color: var(--primary-dark);
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border-radius: 16px;
  border: 1.5px solid var(--primary-dark);
  margin-bottom: 16px;
  padding: 20px 20px;
  outline: none;
  font-size: var(--font-size-6);
  color: var(--primary-light);
}

.FAQItem_question__pzOBd {
  color: var(--primary-light);
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: var(--font-medium), sans-serif;
  font-size: var(--font-size-7);
}

.FAQItem_questionExpanded__ZC6H6 {
  color: var(--primary-accent);
  margin-bottom: 12px;
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: var(--font-semi-bold), sans-serif;
  font-size: var(--font-size-7);
}

.FAQItem_answer__rLdvl {
  transition: all 0.3s ease-in-out;
  line-height: 24px;
  font-family: var(--font-regular), sans-serif;
  font-size: var(--font-size-6);
}

@media (max-width: 767px) {
  .FAQItem_container__4DWj7 {
    padding: 16px;
  }

  .FAQItem_containerExpanded__E4k-Q {
    padding: 16px;
  }

  .FAQItem_question__pzOBd {
    font-size: var(--font-size-5);
  }

  .FAQItem_questionExpanded__ZC6H6 {
    font-size: var(--font-size-5);
  }

  .FAQItem_answer__rLdvl {
    font-size: var(--font-size-4);
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .FAQItem_question__pzOBd {
    font-size: var(--font-size-5);
  }

  .FAQItem_questionExpanded__ZC6H6 {
    font-size: var(--font-size-5);
  }

  .FAQItem_answer__rLdvl {
    font-size: var(--font-size-4);
  }
}

@media (min-width: 1024px) {
  .FAQItem_question__pzOBd {
    font-size: var(--font-size-5);
  }

  .FAQItem_questionExpanded__ZC6H6 {
    font-size: var(--font-size-5);
  }

  .FAQItem_answer__rLdvl {
    font-size: var(--font-size-4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/Help/FAQItem/FAQItem.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".container {\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  background-color: transparent;\n  border-radius: 16px;\n  border: 1.5px solid var(--primary-dark);\n  margin-bottom: 16px;\n  padding: 20px 20px;\n  outline: none;\n  font-size: var(--font-size-6);\n  color: var(--primary-light);\n}\n\n.containerExpanded {\n  background-color: var(--primary-dark);\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  border-radius: 16px;\n  border: 1.5px solid var(--primary-dark);\n  margin-bottom: 16px;\n  padding: 20px 20px;\n  outline: none;\n  font-size: var(--font-size-6);\n  color: var(--primary-light);\n}\n\n.question {\n  color: var(--primary-light);\n  transition: all 0.3s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-family: var(--font-medium), sans-serif;\n  font-size: var(--font-size-7);\n}\n\n.questionExpanded {\n  color: var(--primary-accent);\n  margin-bottom: 12px;\n  transition: all 0.3s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-family: var(--font-semi-bold), sans-serif;\n  font-size: var(--font-size-7);\n}\n\n.answer {\n  transition: all 0.3s ease-in-out;\n  line-height: 24px;\n  font-family: var(--font-regular), sans-serif;\n  font-size: var(--font-size-6);\n}\n\n@media (max-width: 767px) {\n  .container {\n    padding: 16px;\n  }\n\n  .containerExpanded {\n    padding: 16px;\n  }\n\n  .question {\n    font-size: var(--font-size-5);\n  }\n\n  .questionExpanded {\n    font-size: var(--font-size-5);\n  }\n\n  .answer {\n    font-size: var(--font-size-4);\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1023px) {\n  .question {\n    font-size: var(--font-size-5);\n  }\n\n  .questionExpanded {\n    font-size: var(--font-size-5);\n  }\n\n  .answer {\n    font-size: var(--font-size-4);\n  }\n}\n\n@media (min-width: 1024px) {\n  .question {\n    font-size: var(--font-size-5);\n  }\n\n  .questionExpanded {\n    font-size: var(--font-size-5);\n  }\n\n  .answer {\n    font-size: var(--font-size-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FAQItem_container__4DWj7`,
	"containerExpanded": `FAQItem_containerExpanded__E4k-Q`,
	"question": `FAQItem_question__pzOBd`,
	"questionExpanded": `FAQItem_questionExpanded__ZC6H6`,
	"answer": `FAQItem_answer__rLdvl`
};
export default ___CSS_LOADER_EXPORT___;
